"use client";
/**
 * Renders a real QR code (via the bundled `qrcode` dep) to a canvas. Used by
 * the referral "Show QR" modal (design 1.9) so a friend can scan the referral
 * link in person.
 */
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";

export function QrCode({
  value,
  size = 170,
}: {
  value: string;
  size?: number;
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !value) return;
    let cancelled = false;
    QRCode.toCanvas(canvas, value, {
      width: size,
      margin: 1,
      color: { dark: "#1a201d", light: "#ffffff" },
      errorCorrectionLevel: "M",
    }).catch(() => {
      if (!cancelled) setFailed(true);
    });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (failed) {
    return (
      <div
        style={{
          width: size,
          height: size,
          display: "grid",
          placeItems: "center",
          background: "#fff",
          borderRadius: 8,
          color: "var(--ink-3)",
          fontSize: 12,
        }}
      >
        QR
      </div>
    );
  }

  return (
    <canvas
      ref={canvasRef}
      width={size}
      height={size}
      style={{ width: size, height: size, display: "block", borderRadius: 8 }}
    />
  );
}
